(() => {
  const SELECTOR = '[data-irriga-search-suggestions]';
  function initialize(form) {
    if (form.dataset.searchSuggestionsReady === 'true') return;
    const input = form.querySelector('input[type="search"]');
    const field = form.querySelector('.irriga-search-gooey-field');
    const searchButton = form.querySelector('.search__button');
    if (!input) return;
    let suggestions;
    try { suggestions = JSON.parse(form.dataset.suggestions || '[]').filter(Boolean); }
    catch { suggestions = []; }
    if (suggestions.length < 2) return;
    form.dataset.searchSuggestionsReady = 'true';
    let index = 0;
    let timer = 0;
    function rotate() {
      if (input.value) return;
      input.classList.add('is-changing-placeholder');
      window.setTimeout(() => {
        index = (index + 1) % suggestions.length;
        input.placeholder = suggestions[index];
        input.classList.remove('is-changing-placeholder');
      }, 180);
    }
    function start() {
      window.clearInterval(timer);
      if (!document.hidden) timer = window.setInterval(rotate, 6000);
    }
    if (field && searchButton) {
      function setSeparated(separated) { field.classList.toggle('is-separated', separated); }
      searchButton.addEventListener('click', (event) => {
        if (field.classList.contains('is-separated') && input.value) return;
        event.preventDefault();
        setSeparated(true);
        requestAnimationFrame(() => input.focus({ preventScroll: true }));
      });
      field.addEventListener('click', (event) => {
        if (event.target.closest('button')) return;
        setSeparated(true);
        if (document.activeElement !== input) input.focus({ preventScroll: true });
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !input.value) {
          setSeparated(false);
          input.blur();
        }
      });
      field.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!field.contains(document.activeElement) && !input.value) setSeparated(false);
        }, 0);
      });
      setSeparated(Boolean(input.value));
    }
    document.addEventListener('visibilitychange', start);
    start();
  }
  function scan(scope = document) {
    if (scope.nodeType === Node.ELEMENT_NODE && scope.matches(SELECTOR)) initialize(scope);
    scope.querySelectorAll(SELECTOR).forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
